import { render, staticRenderFns } from "./tollFee.vue?vue&type=template&id=a3be0188&scoped=true&"
import script from "./tollFee.vue?vue&type=script&lang=js&"
export * from "./tollFee.vue?vue&type=script&lang=js&"
import style0 from "./tollFee.vue?vue&type=style&index=0&id=a3be0188&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3be0188",
  null
  
)

export default component.exports